<template>
  <div>
    <ReactWrapper :component="Organization" />
  </div>
</template>

<script>
  import { Organization } from '../../../../../frontendV2/dist/reactComponents';
  import ReactWrapper from '@/components/blocks/reactComponents/ReactWrapper';

  export default {
    name: 'Organization',

    components: {
      ReactWrapper,
    },

    data: () => ({
      Organization,
    }),
  };
</script>
